import { render, staticRenderFns } from "./LegalParametersView.vue?vue&type=template&id=aa2b66fe"
import script from "./LegalParametersView.vue?vue&type=script&lang=js"
export * from "./LegalParametersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports